module.exports = __webpack_public_path__ + "media/tape-nav/commerce-business-find-icon-9bc3293b.svg";